import Layout from "../../components/custom/Layout";

export default function SignatureReport () {
    return (
        <Layout>
            <iframe style={{ width: '100%', height: '100%' }} src={'https://app.powerbi.com/view?r=eyJrIjoiOTdiMDU0NjEtNmNlMS00OWU0LTllZGItMTk1NjU0OGNhZDcwIiwidCI6IjM2ZjljMDIyLTEyY2YtNDgzYy04OWM4LWI1ZWYxZjgwZGNjZSIsImMiOjF9'} />
        </Layout>
    );
}